module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kp-file-upload"
  }, [_c('ul', {
    staticClass: "img-group clear"
  }, [_c('file-upload', {
    ref: "upload",
    staticClass: "fl",
    attrs: {
      "name": _vm.name,
      "accept": "image/*",
      "multiple": _vm.multiple,
      "timeout": 600 * 1000,
      "headers": _vm.setHeader,
      "post-action": _vm.uploadUrl,
      "maximum": _vm.maxLength
    },
    on: {
      "input-file": _vm.inputFile,
      "input-filter": _vm.inputFilter
    },
    model: {
      value: (_vm.files),
      callback: function($$v) {
        _vm.files = $$v
      },
      expression: "files"
    }
  }, [(_vm.isEdit && _vm.multiple && _vm.files.length < _vm.maxLength) ? _c('div', {
    staticClass: "file-add fl"
  }, [_c('div', {
    staticClass: "vertical-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "horizontal1-line"
  })]) : (_vm.isEdit && !_vm.multiple && _vm.files.length < _vm.maxLength) ? _c('div', [_vm._v("点击上传")]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.files), function(file, index) {
    return _c('li', {
      key: index,
      staticClass: "fl",
      class: _vm.getClassType.li
    }, [_c('img', {
      staticClass: "file-img previewer-demo-img",
      attrs: {
        "src": file.blob,
        "alt": _vm.getImgFileReallyName(file.name)
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.preview(index)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "del-img",
      on: {
        "click": function($event) {
          return _vm.del(file, index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o",
      class: _vm.getClassType.delIcon
    })])])
  })], 2), _vm._v(" "), (_vm.isEdit && _vm.multiple && _vm.maxLength > 1) ? _c('div', {
    staticClass: "describe"
  }, [_vm._v("共选择了 " + _vm._s(_vm.files.length) + " 张图片，最多只能上传 " + _vm._s(_vm.maxLength) + " 图片")]) : (!_vm.isEdit && _vm.multiple && _vm.maxLength > 1) ? _c('div', {
    staticClass: "describe"
  }, [_vm._v("共 " + _vm._s(_vm.files.length) + " 张图片")]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('previewer', {
    ref: "previewer",
    attrs: {
      "list": _vm.files,
      "options": _vm.options
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b648d68","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/plugin/KpFileUpload.vue
// module id = 319
// module chunks = 1